import ReactSelect, { createFilter } from 'react-select'
import CustomMenuList from '../../../../Form/Select/CustomMenuList'
import CustomOption from '../../../../Form/Select/CustomOption'
import { Portal } from '@chakra-ui/react'

const SelectCell = ({
  getValue,
  row: { index },
  column: { id },
  table,
  isFilter = false,
  options,
  extraDisable = false,
}) => {
  const initialValue = getValue()
  const isDisabled = table?.options?.meta?.disabled || extraDisable

  const selectedOptions = options.find((opt) => opt?.value === initialValue)

  const onChange = (newValue) => {
    //React-table v8 will replace . with _

    table?.options.meta?.updateData(index, id.replace('__', '._'), newValue)
  }

  return (
    <ReactSelect
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        container: (base) => ({
          ...base,
        }),
      }}
      filterOption={createFilter({ ignoreAccents: false })}
      options={options}
      value={selectedOptions}
      onChange={(option) => {
        onChange(option?.value)
      }}
      components={{ Option: CustomOption, MenuList: CustomMenuList }}
      isDisabled={isDisabled}
      isClearable={!isDisabled}
      menuPortalTarget={document.body}
    />
  )
}

export default SelectCell
